var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('aeroHeader'),_c('router-view',{staticClass:"router"}),_c('aeroMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }